import * as S from './styles'

const FirstStep = () => (
  <S.FirstStepIframe
    src="https://wexerpsi.tawk.help/article/boas-vindas"
    frameBorder="0"
  />
)

export default FirstStep
